import { Service } from '@phishtool/service';
import getHomepageContentController from '~controllers/service/content/get-homepage-content';
import getMSSPPageContentController from '~controllers/service/content/get-mssp-page-content';
import getComplianceDocumentController from '~server/controllers/service/content/get-compliance-document';
export class ContentService extends Service {
    constructor() {
        super(...arguments);
        this.useGetHomepageContent = this.addCollectionNonResourceQuery({
            routeId: 'home',
            controller: getHomepageContentController,
            middleware: [],
            opts: {
                staleTime: Infinity,
            },
        });
        this.useGetMSSPContent = this.addCollectionNonResourceQuery({
            routeId: 'mssp',
            controller: getMSSPPageContentController,
            middleware: [],
            opts: {
                staleTime: Infinity,
            },
        });
        this.getComplianceDocumentUrl = this.addSingletonFileQuery({
            controller: getComplianceDocumentController,
            routeId: 'pdf',
            middleware: [],
        });
    }
}
